module.exports = __webpack_public_path__ + "static/media/dcdb-papa-hero-desktop.ac797087.jpg";